import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
export default function curry(f) {
  return function (a) {
    var _context;

    for (var _len = arguments.length, _ = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      _[_key - 1] = arguments[_key];
    }

    return _.length ? f.apply(void 0, _concatInstanceProperty(_context = [a]).call(_context, _)) : function () {
      var _context2;

      for (var _len2 = arguments.length, _ = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        _[_key2] = arguments[_key2];
      }

      return f.apply(void 0, _concatInstanceProperty(_context2 = [a]).call(_context2, _));
    };
  };
}